/**
 * Shared types and utilities for funding calculations.
 * This file exists to break circular dependencies between funding calculation modules.
 */

export type ReturnOnInvestmentCalculations = {
  investments: CashFlow[];
  returns: CashFlow[];
  investmentPeriodYears: number;
};

// `asOf` pins "today". It defaults to now, but the elapsed-months branch below
// makes this the most drift-prone helper in the calc — its result changes every
// MONTH, not just every January — so in-pipeline callers must pass the derivative
// pass's `asOfDate` (see `resolveAsOfDate`).
export function calculateMonthsBetweenYears(
  startYear: number,
  endYear: number,
  asOf: Date = new Date(),
): number {
  const currentYear: number = asOf.getFullYear();
  const monthsInYear: number = 12;

  // Check for invalid input
  if (startYear > endYear) {
    return 0;
  }

  // Calculate the difference in years
  const yearDifference: number = endYear - startYear;

  if (startYear === currentYear) {
    // If the start year is the current year, calculate months passed in the current year
    const monthsPassedInCurrentYear: number = asOf.getMonth() + 1;
    return yearDifference * monthsInYear - monthsPassedInCurrentYear;
  } else {
    // Calculate the total months based on the year difference
    const totalMonths: number = yearDifference * monthsInYear;
    return totalMonths;
  }
}
